import React, { useState } from "react";
import { Modal } from "antd";
import { HeartOutlined } from "@ant-design/icons";
import { content } from "./content";

import amcLogo from "./assets/amc-logo.png";
import ksApsLogo from "./assets/ks-aps-logo.png";
import kapSurveyLogo from "./assets/kapsurvey-logo.svg";

// Rename the key to show the window again to everyone, e.g. after the text changes.
export const WELCOME_STORAGE_KEY = "tetori-roze-2026:welcome-confirmed-v2";

// Storage can be missing or throw, even on `window.localStorage` itself (private windows, blocked
// site data). The window then shows on every visit, and the button still closes it for this one.
export const isWelcomeConfirmed = (storage) => {
   try {
      return (storage ?? window.localStorage).getItem(WELCOME_STORAGE_KEY) === "1";
   } catch {
      return false;
   }
};

export const rememberWelcomeConfirmed = (storage) => {
   try {
      (storage ?? window.localStorage).setItem(WELCOME_STORAGE_KEY, "1");
   } catch {
      // Nothing to remember it in: see isWelcomeConfirmed.
   }
};

// The campaign's invitation, shown once per browser until the respondent presses the
// button. Only the button closes it: closing it any other way would show it again next time.
const TetoriRozeWelcome = () => {
   const [isOpen, setIsOpen] = useState(() => !isWelcomeConfirmed());
   const { hero, welcome } = content;

   const handleConfirm = () => {
      rememberWelcomeConfirmed();
      setIsOpen(false);
   };

   return (
      <Modal
         open={isOpen}
         // The modal renders in a portal: `tr-theme` gives it the theme's colours and fonts.
         rootClassName="tr-theme tr-welcome-root"
         className="tr-welcome"
         width={680}
         centered
         footer={null}
         closable={false}
         maskClosable={false}
         keyboard={false}
      >
         <div className="tr-welcome__top">
            <div className="tr-welcome__logos">
               <span className="tr-welcome__powered">
                  <span className="tr-welcome__powered-label">{hero.logos.poweredBy}</span>
                  <img
                     className="tr-welcome__logo"
                     src={kapSurveyLogo}
                     alt={hero.logos.kapSurvey}
                  />
               </span>
               <span className="tr-welcome__logo-divider" aria-hidden="true" />
               <img className="tr-welcome__logo" src={ksApsLogo} alt={hero.logos.ksAps} />
               <span className="tr-welcome__logo-divider" aria-hidden="true" />
               <img className="tr-welcome__logo" src={amcLogo} alt={hero.logos.amc} />
            </div>
            <span className="tr-welcome__badge" aria-hidden="true">
               <HeartOutlined />
            </span>
         </div>

         <h2 className="tr-welcome__title">{welcome.title}</h2>

         <ul className="tr-welcome__questions">
            {welcome.questions.map((question) => (
               <li key={question}>{question}</li>
            ))}
         </ul>

         <p className="tr-welcome__text">{welcome.text}</p>
         <p className="tr-welcome__highlight">{welcome.highlight}</p>

         <div className="tr-welcome__footer">
            <p className="tr-welcome__cta">{welcome.callToAction}</p>
            <button type="button" className="tr-btn tr-btn--primary" onClick={handleConfirm}>
               {welcome.confirm}
            </button>
         </div>
      </Modal>
   );
};

export default TetoriRozeWelcome;
